import React from "react";
import { Link } from "react-router-dom";

const ForgetCredentialFooterLink = () => {
	return (
		<div className="forgot-credentials-link-container">
			<span>Do you need any help?</span>
			<div>
				<span className="link-container">
					<Link className="forgot-username-link" to="/forget-user-name">
						Forgot Username
					</Link>
				</span>
				&nbsp; or &nbsp;
				<span className="link-container">
					<Link className="forgot-password-link" to="/forget-password">
						Forgot Password
					</Link>
				</span>
			</div>
		</div>
	);
};

export default ForgetCredentialFooterLink;
